import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/modern-restaurant.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Layout from './Components/Layout';
import Home from './Components/Home/Home';
import RestaurentList from "./Components/Restaurent/RestaurentList";
// Cart, Checkout, Order flow hidden – ordering only on mobile app (Zomato-style)
// import Cart from "./Components/Cart/Cart";
// import Checkout from "./Components/Checkout/Checkout";
// import OrderList from "./Components/Order/OrderList";
import DownloadAppPage from "./Components/DownloadApp/DownloadAppPage";
import Support from "./Components/Support/Support";
import Chat from "./Components/Support/Chat";
import AboutUs from "./Components/Cms/AboutUs";
import PrivacyPolicy from "./Components/Cms/PrivacyPolicy";
import RefundPolicy from "./Components/Cms/RefundPolicy";
import TermsCondition from "./Components/Cms/TermsCondition";
import ShippingPolicy from "./Components/Cms/ShippingPolicy";
import Map from "./Components/Checkout/Map";
import Profile from './Components/Layout/Authentication/Profile';
import Favourite from './Components/Favourite/Favourite';
import CategoryRestaurent from './Components/Restaurent/CategoryRestaurent';
import Notification from './Components/Notifications/Notification';
// import MyOrder from './Components/Order/MyOrder';
import TrackOrder from './Components/Order/TrackOrder';
import ContactUs from './Components/Contact/ContactUs';
import PageNotFound from './Components/Page404/PageNotFound';
import Wallet from './Components/wallet/Wallet';

// ToastContainer removed - using custom alert modal instead
import { getCommonSetting, getUserProfile, logoutUser } from './redux/features/auth/authSliceNew';
import { setupInterceptors } from './Components/Services/axios';
import { cleanupModalBackdrops } from './helper/useScrollToTop';

import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


function App() {
  const dispatch = useDispatch();
  const { isLogin, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    // Always fetch common settings (public endpoint)
    dispatch(getCommonSetting());
    
    // Only fetch user profile if token exists
    const token = localStorage.getItem('token');
    if (token) {
      dispatch(getUserProfile());
    }
  }, [dispatch]);

  useEffect(() => {
    setupInterceptors(() => dispatch(logoutUser()));
  }, [dispatch]);

// When user logs in, hide login modal and clean up backdrops
  useEffect(() => {
    if (!loading && isLogin) {
      try {
        const loginModalEl = document.getElementById('login-modal');
        if (loginModalEl && window.bootstrap && window.bootstrap.Modal) {
          const instance = window.bootstrap.Modal.getInstance(loginModalEl) || new window.bootstrap.Modal(loginModalEl);
          instance.hide();
        }
      } catch (e) {}
      cleanupModalBackdrops();
    }
  }, [loading, isLogin]);




  return (
    <>
      <BrowserRouter>
        <Routes>
          <>
            <Route path="/" element={< Layout />}>
              <Route index element={<Home />} />
              <Route path="/restaurent-list/:id" element={<RestaurentList />} />
              {/* Cart, Checkout, Order routes – redirect to download app page; original routes commented below */}
              {/* <Route path="/cart" element={< Cart />} /> */}
              {/* <Route path="/checkout" element={<Checkout />} /> */}
              <Route path="/cart" element={<DownloadAppPage />} />
              <Route path="/checkout" element={<DownloadAppPage />} />
              <Route path="/my-order" element={<DownloadAppPage />} />
              <Route path="/order-details/:id" element={<DownloadAppPage />} />
              {/* <Route path="/my-order" element={<MyOrder />} /> */}
              {/* <Route path="/order-details/:id" element={<OrderList />} /> */}
              <Route path="/support" element={<Support />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/term-condition" element={<TermsCondition />} />
              <Route path="/map" element={<Map />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/favourite" element={<Favourite />} />
              <Route path="/categoryrestaurent/:id/:name" element={<CategoryRestaurent />} />
              <Route path="/notification" element={<Notification />} />
              <Route path="/track-order/:id" element={<TrackOrder />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/wallet" element={<Wallet />} />
            </Route>
            <Route path="/*" element={<PageNotFound />} />
          </>
        </Routes>
      </BrowserRouter>
      {/* ToastContainer removed - using custom alert modal instead */}
    </>
  );
}

export default App;